import React from 'react';

type PropsType = React.SVGProps<SVGSVGElement>;

const YoutubeIcon: React.FC<PropsType> = props => (
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0071 0.554151C22.0002 0.681201 22.9492 1.62956 23.07 2.61858C23.4975 6.24318 23.4975 9.75795 23.07 13.3814C22.9492 14.3704 22.0002 15.3199 21.0071 15.4458C14.952 16.1847 8.82841 16.1847 2.77498 15.4458C1.78107 15.3196 0.832018 14.3704 0.711265 13.3814C0.283745 9.75767 0.283745 6.24318 0.711265 2.61858C0.832018 1.62956 1.78107 0.680919 2.77498 0.554151C8.82841 -0.184717 14.9517 -0.184717 21.0071 0.554151ZM10.3906 4V12L16.3906 8.00015L10.3906 4Z"
      fill="currentColor"
    />
  </svg>
);

export default YoutubeIcon;
